import { render, staticRenderFns } from "./addPosition.vue?vue&type=template&id=54dd8c19&scoped=true"
import script from "./addPosition.vue?vue&type=script&lang=js"
export * from "./addPosition.vue?vue&type=script&lang=js"
import style0 from "./addPosition.vue?vue&type=style&index=0&id=54dd8c19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd8c19",
  null
  
)

export default component.exports